import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../../../services/firebaseFunctions';

type RegisterAdminResponse = {
  error?: 'ADMIN_EMAIL_INVALID' | 'ADMIN_EMAIL_BLOCKED' | 'ADMIN_EMAIL_TAKEN';
  result: boolean;
};

type CompleteRegistrationResponse = {
  error?: 'ADMIN_EMAIL_INVALID' | 'INVALID_TOKEN' | 'WEAK_PASSWORD';
  result: boolean;
};

export const registerAdminUser = (data: {
  email: string;
  firstName: string;
  lastName: string;
}) =>
  callFirebaseFunction<RegisterAdminResponse>(
    CF.adminUser.registerAdminUser,
    data
  );

export const completeAdminRegistration = (data: {
  email: string;
  password: string;
  token: string;
}) =>
  callFirebaseFunction<CompleteRegistrationResponse>(
    CF.adminUser.completeAdminRegistration,
    data
  );
